import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { BillingEstimate, BillingEstimateParams } from '@recruitee/billing-estimate-types';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class BillingPlansHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchBillingPlans() {
    return this.httpApi.get('/billing/plans');
  }

  public fetchActiveBillingPlan() {
    return this.httpApi.get('/billing/subscription/plan');
  }

  public fetchBillingEstimate(params: BillingEstimateParams): Observable<BillingEstimate> {
    return this.httpApi.post('/billing/estimate', null, params).pipe(map(data => data.estimate));
  }
}
